import { CreditCardStatus } from "./CreditCard";

import OfferCard from "./OfferCard";

import UserRegistrationData from "./UserRegistrationData";

import OfferPage from "types/OfferPage";

export enum Status {
  active = "active",
  pendingActivation = "pendingActivation",
  purchasableExternally = "purchasableExternally",
  purchasable = "purchasable",
  notPurchasable = "notPurchasable",
  cancelled = "cancelled",
  provisioning = "provisioning",
  cardExpired = "cardExpired",
  cardPending = "cardPending",
  maintainance = "maintenance",
}

export type SourceType = "banner" | "timeBoundPromo" | "none";

export type BannerContent = {
  name: string;
  partner: string;
  images: Images | undefined;
  action: { type: string; label: string };
  carousel: boolean;
  description: string;
  order: number;
  title: string;
  isVideo?: boolean;
  sourceType: SourceType;
};

export type Banner = BannerContent & {
  timeBoundPromo?: BannerContent;
};

type Offer = {
  disabled?: boolean;
  usergroups?: string[];
  offerSkipBasketFlow?: boolean;
  cardPaymentId?: string;
  logoImage: string;
  type: string;
  alreadyStandalone?: boolean;
  bundlingFlow: boolean;
  comment?: string;
  emailOtp?: boolean;
  heading?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  links?: any;
  chargingMethod?: "NON_RECURRING" | "RECURRING";
  duration?: {
    name: "WEEKLY" | "MONTHLY" | "QUARTERLY";
    code: number;
    months: number;
    days: number;
  };
  multiPlanOffer?: boolean;
  marketplaceInfo: {
    basket?: {
      tiers?: boolean;
      extraInfo?: string;
    };
    deepLink: string;
    logoName: string;
    status: Status;
    upgradePopUpInfo?: string;
    downgradePopUpInfo?: string;
    price: string;
    requireRegForm?: boolean;
    isStartingPrice?: boolean;
    trialInfo?: { amount: number; unit: string; trialPrice: number };
    title: string;
    tag: string;
    customTag: string;
    subTextValue?: string;
    plan?: {
      streams: number;
      quality: string;
      downloads: string;
    };
    cdData?: {
      feature1: {
        displayText: string;
      };
      feature2: {
        displayText: string;
      };
      feature3: {
        displayText: string;
      };
      feature4: {
        displayText: string;
      };
      feature5: {
        displayText: string;
      };
      feature6: {
        displayText: string;
      };
      feature7: {
        displayText: string;
      };
      feature8: {
        displayText: string;
      };
      feature9: {
        displayText: string;
      };
    };
    priceText?: string | undefined;
    tncs?: { title: string; description: string; size: string };
    bookingDetails?: { title: string; details: string };
    privacy?: { description: string };
    contractSummary?: { description: string };
    type?: "standalone" | "hardbundle";
    pages: { [key: string]: OfferPage };
    cards: { [key: string]: OfferCard };
    details?: string;
    agency?: boolean;
    revokeDowngradable?: boolean;
    canBeSwitchTo?: canBeSwitchTo[];
    notEligible?: Record<
      NotEligibleState,
      { heading: string; details: string; hasGoogleButton?: boolean; isModal?: boolean }
    >;
    banner?: Banner;
    paymentConfirmationBox?: string;
    discountOfferText?: string;
  };
  name: string;
  opco: string;
  packageId: string;
  longPackageId?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pages?: any;
  partner: string;
  sameCustomer?: boolean;
  switchable?: boolean;
  upgradable?: boolean;
  downgradable?: boolean;
  trial?: boolean;
  version?: number;
  endDate?: Date | string | null;
  startDate?: Date | string | null;
  reactivable?: boolean;
  cancellable?: boolean;
  cancelled?: boolean;
  setupUrl?: string;
  images?: Images;
  recurring: boolean;
  migratedCustomer: boolean;
  status: Status;
  fromPurchasedArray?: boolean;
  campaign?: string;
  externalPayment?: {
    cardStatus: CreditCardStatus;
    externalPaymentId: string;
    cardLastDigits: string;
  };
  price?: number;
  pricingText1?: string;
  pricingText2?: string;
  subscriptionId?: string;
  usergroup?: string;
  userData?: UserRegistrationData;
};

export type Images = {
  logo: string;
  logoLandscape: string;
  logoWhite: string;
  logoLandscapeWhite: string;
  card: {
    desktop: string;
    tablet: string;
    mobile: string;
  };
  carousel: {
    baseUrl: string;
    promoUrl?: string;
  };
  cross: {
    desktop: string;
    tablet: string;
    mobile: string;
  };
  banner: {
    desktop: string;
    tablet: string;
    mobile: string;
  };
};

type canBeSwitchTo = {
  buttonLabel: string;
  buttonType: string;
  order: number;
  offerName: string;
};

export type NotEligibleState =
  | "not_eligible_for_trial"
  | "account_already_exist"
  | "access_denied"
  | "youtube_partner_error";

export default Offer;
